document.addEventListener('DOMContentLoaded', () => {
    const searchOverlay = document.querySelector('#livSearchOverlay');
    if (!searchOverlay) return;

    const headerElement    = document.querySelector('.liv-header');
    const searchInput = document.querySelector('#livSearchInput');
    const backgroundBlur = document.querySelector('.liv-header__overlay');
    const searchForm = document.querySelector('.liv-header__search-form-wrapper');
    searchForm?.addEventListener('submit', (e) => {
      const query = searchInput.value.trim();
      if (query.length < 1) {
        e.preventDefault();
      }
    });
    const resultsArea      = document.querySelector('#livPredictiveResults');
    const initialView      = document.querySelector('#livSearchInitial');
    const noResultsBox     = document.querySelector('#livSearchNoResults');
    const clearButton      = document.querySelector('#livSearchClear');

    if (!searchInput) return;

    const toggleSearch = (forceClose = false) => {
        const isSearchActive = searchOverlay.classList.contains('is-active');
        if (forceClose || isSearchActive) {
            searchOverlay.classList.remove('is-active');
            if (!document.querySelector('#livMobileDrawer')?.classList.contains('is-open')) {
                backgroundBlur?.classList.remove('is-active');
                document.body.classList.remove('menu_visible');
                document.documentElement.classList.remove('liv-no-scroll');
            }
        } else {
            window.dispatchEvent(new CustomEvent('liv:search:open'));
            searchOverlay.classList.add('is-active');
            backgroundBlur?.classList.add('is-active');
            document.body.classList.add('menu_visible');
            document.documentElement.classList.add('liv-no-scroll');
            setTimeout(() => searchInput.focus(), 300);
        }
    };

            let abortController = null;
            const runPredictiveSearch = async (query) => {
                // Fix race condition: abort any pending search immediately
                if (abortController) abortController.abort();
                
                if (clearButton) clearButton.style.display = query.length > 0 ? 'block' : 'none'; 
                
                const hasNumbers = /\d/.test(query.trim());
                
                if (query.length < 1 || hasNumbers) {
                    initialView.style.display = 'block';
                    const grid = initialView.querySelector('.liv-header__search-cols');
                    if (grid) grid.style.display = hasNumbers ? 'none' : 'flex';
                    
                    resultsArea.style.display = 'none';
                    resultsArea.innerHTML = ''; // Explicitly clear old results
                    
                    if (noResultsBox) noResultsBox.style.display = hasNumbers ? 'block' : 'none';
                    return;
                }

                abortController = new AbortController();

                try {
                    const url = `${window.Shopify.routes.root}search/suggest`;
                    const params = `?q=${encodeURIComponent(query)}&resources[type]=product,collection,page,article&resources[options][prefix]=last&resources[options][fields]=title,product_type,variants.title,vendor,tag,body`;
                    
                    const [jsonResponse, htmlResponse] = await Promise.all([
                        fetch(`${url}.json${params}`, { signal: abortController.signal }),
                        fetch(`${url}${params}&section_id=predictive-search`, { signal: abortController.signal })
                    ]);

                    if (!jsonResponse.ok || !htmlResponse.ok) throw new Error('Search request failed');

                    const [suggestions, htmlContent] = await Promise.all([
                        jsonResponse.json(),
                        htmlResponse.text()
                    ]);

                    const results = suggestions?.resources?.results;
                    let hasResults = results ? Object.values(results).some(arr => Array.isArray(arr) && arr.length > 0) : false;
                    const hasHtml = htmlContent && htmlContent.trim().length > 0;

                    if (hasHtml && htmlContent.includes('liv-search__item')) {
                        hasResults = true;
                    }

                    if (hasResults && hasHtml) {
                        resultsArea.innerHTML = htmlContent;

                        const titleProducts = resultsArea.getAttribute('data-title-products');
                        const titleCollections = resultsArea.getAttribute('data-title-collections');
                        const titlePages = resultsArea.getAttribute('data-title-pages');
                        
                        if (titleProducts) {
                            const cp = resultsArea.querySelector('#search-tab-products .liv-search__col-title');
                            if (cp) cp.textContent = titleProducts;
                        }
                        if (titleCollections) {
                            const cc = resultsArea.querySelector('#search-tab-collections .liv-search__col-title');
                            if (cc) cc.textContent = titleCollections;
                        }
                        if (titlePages) {
                            const cp = resultsArea.querySelector('#search-tab-pages .liv-search__col-title');
                            if (cp) cp.textContent = titlePages;
                        }

                        initialView.style.display = 'none';
                        resultsArea.style.display = 'block';
                        if (noResultsBox) noResultsBox.style.display = 'none';
                    } else {
                        resultsArea.style.display = 'none';
                        initialView.style.display = 'block';
                        const grid = initialView.querySelector('.liv-header__search-cols');
                        if (grid) grid.style.display = 'none';
                        if (noResultsBox) noResultsBox.style.display = 'block';
                    }
                } catch (error) {
                    if (error.name !== 'AbortError') {
                        console.error('Search error:', error);
                        // Fallback: show initial view if search fails
                        initialView.style.display = 'block';
                        const grid = initialView.querySelector('.liv-header__search-cols');
                        if (grid) grid.style.display = 'flex';
                        resultsArea.style.display = 'none';
                        if (noResultsBox) noResultsBox.style.display = 'none';
                    }
                }
            };

    document.addEventListener('click', (event) => {
        const isSearchActive = searchOverlay.classList.contains('is-active');
        const triggerElement = event.target.closest('.header__search, .liv-header__search-icon, #livSearchClose');
        
        if (triggerElement) {
            event.preventDefault(); toggleSearch(); return;
        }

        if (isSearchActive) {
            const isInsideContent = event.target.closest('.liv-header__search-inner');
            if (!isInsideContent) {
                toggleSearch(true);
            } else {
                const suggestionPill = event.target.closest('.liv-header__search-pill');
                if (suggestionPill) {
                    event.preventDefault();
                    searchInput.value = suggestionPill.textContent.trim();
                    runPredictiveSearch(searchInput.value);
                }
                if (event.target.closest('#livSearchClear')) {
                    searchInput.value = ''; runPredictiveSearch(''); searchInput.focus();
                }
                const mobileTabElement = event.target.closest('.liv-search__mobile-tab');
                if (mobileTabElement && resultsArea) {
                    resultsArea.querySelectorAll('.liv-search__mobile-tab').forEach(button => button.classList.toggle('is-active', button === mobileTabElement));
                    resultsArea.querySelectorAll('.liv-search__col').forEach(column => column.classList.toggle('is-active', column.id === `search-tab-${mobileTabElement.dataset.tab}`));
                }
            }
        }
    });

    searchInput.addEventListener('input', (event) => runPredictiveSearch(event.target.value.trim()));
    window.addEventListener('keydown', (event) => event.key === 'Escape' && toggleSearch(true));
    window.addEventListener('liv:menu:open', () => toggleSearch(true));
    window.livCloseSearch = () => toggleSearch(true);
});


